import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLOSE_ATTACHMENTS, CLOSE_DATISALUTE, OPEN_ATTACHMENTS, OPEN_DATISALUTE, UPDATE_COUNT_ATTACHMENTS, UPDATE_PATIENT_LINK, } from './actionTypes';
const DEFAULT_STATE = {
    isOpen: false,
    _nbAttachments: 0,
};
const DEFAULT_STATE_DS = {
    isOpen: false,
    patientLink: ''
};
ReducerRegistry.register('features/attachments', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case OPEN_ATTACHMENTS:
            return {
                ...state,
                isOpen: true,
            };
        case CLOSE_ATTACHMENTS:
            return {
                ...state,
                isOpen: false,
            };
        case UPDATE_COUNT_ATTACHMENTS:
            return {
                ...state,
                _nbAttachments: action.count
            };
    }
    return state;
});
ReducerRegistry.register('features/datisalute', (state = DEFAULT_STATE_DS, action) => {
    switch (action.type) {
        case OPEN_DATISALUTE:
            return {
                ...state,
                isOpen: true
            };
        case CLOSE_DATISALUTE:
            return {
                ...state,
                isOpen: false
            };
        case UPDATE_PATIENT_LINK:
            return {
                ...state,
                patientLink: action.link
            };
    }
    return state;
});
